import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Layout, Tag, Pagination } from "../../components"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { list, remove } from "../../api/Dealer"

/* Router */
import { Link } from "react-router-dom"

/* Helpers */
import { withRouter, utils } from "../../helpers"

/* Sweet alert */
import Swal from "sweetalert2"

/* Modal */
import Modal from "react-modal"

/* HTML to PNG */
import { toPng } from "html-to-image"

/* Barcode */
import Barcode from "react-barcode"

/* Download JS */
import download from "downloadjs"

/* Fields */
const PERCENTAGE = 90 / 3



/* Page Dealers */
class Dealers extends Component {

    constructor() {
        super()

        this.state = {
            data: [],
            status: "loading",
            count: 0,

            active: null,
            qr: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    componentDidUpdate = (prevProps) => {
        const { params } = this.props
        const { page } = params

        if (prevProps.params.page !== page) {
            this.load()
        }
    }

    /* Get Page */
    getPage = () => {

        const { params } = this.props
        const { page } = params

        if (Number.isInteger(parseInt(page))) {
            return parseInt(page)
        }

        return 1
    }

    /* Load action */
    load = (reload = false) => {

        const page = this.getPage()

        if (reload) {
            this.setState({ status: "loading" })
        }

        list(page).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })

    }


    /* Remove action */
    remove = (id) => {

        const { data } = this.state

        Swal.fire({
            title: t("swal.deleteConfirm"),
            text: t("swal.deleteWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: t("swal.deleteButton"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                remove({ id }).then((response) => {
                    if (response.status === 200) {
                        const index = data.findIndex((e) => parseInt(e.id) === parseInt(id))

                        if (index > -1) {
                            const newData = data
                            newData.splice(index, 1)
                            this.setState({ data: newData })
                        }

                        Swal.fire(utils.notification(t("dealer.deletedSuccess"), "success"))
                    }
                    else if (response.status === 401 || response.status === 403) {
                        Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                    }
                    else if (response.status === 498) {
                        Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                    }
                    else {
                        Swal.fire(utils.notification(t("swal.generic"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                })
            }
        })
    }


    /* Download PNG */
    downloadPNG = () => {

        const { active } = this.state
        const qr = document.getElementById("qr-image")

        toPng(qr).then((url) => {
            download(url, `${active.name}-qr-code.png`)
        })

    }


    /* Draw QR Code */
    _qr = () => {

        /* Fields */
        const { active, qr } = this.state

        return (
            <Modal
                isOpen={qr}
                onRequestClose={() => this.setState({ active: null, qr: false })}
                className="dealer-qr-modal"
                overlayClassName="dealer-qr-overlay"
                closeTimeoutMS={200}
            >

                <div className="dealer-qr-header">
                    <h2>{t("dealer.qrCode")}</h2>
                    <div onClick={() => this.setState({ active: null, qr: false })} className="dealer-qr-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {active &&
                    <div className="dealer-qr-container">

                        <div className="dealer-qr-container-image" id="qr-image">

                            <div className="dealer-qr-container-head">
                                <div className="dealer-qr-container-logo">Cuba<span>GO</span></div>
                                <img src="/images/croupier-qr.png" alt="Dealer" />
                            </div>

                            <Barcode value={utils.checkValue(active.pincode, "")} displayValue={false} format="CODE39" />

                            <div className="dealer-qr-container-bottom">

                                <div className="dealer-qr-container-bottom-box">
                                    <div className="dealer-qr-container-bottom-text">Dealer</div>
                                    <div className="dealer-qr-container-bottom-value">{utils.checkValue(active.name, "")}</div>
                                </div>

                                <div className="dealer-qr-container-bottom-box">
                                    <div className="dealer-qr-container-bottom-text">Pincode</div>
                                    <div className="dealer-qr-container-bottom-value">{utils.checkValue(active.pincode, "")}</div>
                                </div>

                            </div>

                        </div>

                        <div onClick={() => this.downloadPNG()} className="dealer-qr-download-png">{t("dealer.downloadPng")}</div>

                    </div>
                }

            </Modal>
        )
    }


    render = () => {

        const { status, data, count } = this.state
        const { navigate } = this.props
        const page = this.getPage()

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("dealer.title")}</h1>
                    <Link to="/dealer/create" className="button">
                        <img src="/images/plus.png" alt="Plus" />
                        <span>{t("dealer.add")}</span>
                    </Link>
                </div>

                <div className="page-table">

                    <div className="page-table-header">
                        <div className="page-table-column number">#</div>
                        <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>{t("dealer.name")}</div>
                        <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>PIN / Barcode</div>
                        <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>{t("dealer.gamesCount")}</div>
                        <div className="page-table-column more"></div>
                    </div>

                    {data.map((item, index) =>
                        <div className="page-table-body dealers" key={`${index}`}>

                            <div className="page-table-column number">{page * (index + 1)}</div>
                            <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>{item.name}</div>
                            <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>
                                <Tag color="pink">{item.pincode}</Tag>
                            </div>

                            <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>
                                <Tag color="purple">{item.gamecount}</Tag>
                            </div>

                            <div className="page-table-column more">

                                <div className="more-dropdown-menu-icon">
                                    <img src="/images/dots-more.png" alt="More Dot" />
                                </div>

                                <div className="more-dropdown-menu">

                                    <div onClick={() => this.setState({ active: item, qr: true })} className="more-dropdown-menu-item">
                                        <img src="/images/qr-code.png" alt="QR" />
                                        <span>{t("dealer.qrCode")}</span>
                                    </div>

                                    <Link to={`/dealer/edit/${item.id}`} className="more-dropdown-menu-item">
                                        <img src="/images/editing.png" alt="Edit" />
                                        <span>{t("dealer.edit")}</span>
                                    </Link>

                                    <div onClick={() => this.remove(item.id)} className="more-dropdown-menu-item red">
                                        <img src="/images/remove.png" alt="Remove" />
                                        <span>{t("dealer.delete")}</span>
                                    </div>

                                </div>

                            </div>

                        </div>
                    )}

                    <Pagination size={10} page={page} total={count} onPageChange={(page) => navigate(`/dealer/${page}`)} />

                </div>

                {this._qr()}

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(Dealers))